import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject, takeUntil, lastValueFrom } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { VetUserNotificationSettingComponent } from '../../settings/vet-user-notification-setting/vet-user-notification-setting.component';
import { BaseUnsubscribeComponent } from '../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ToastService } from '../../shared-new/services/toast.service';
import { EventsEmitter } from '../../shared/event-emitter/EventEmitter';
import { UserProfileComponent } from '../user-profile/user-profile.component';
import { VetProfileComponent } from '../vet-profile/vet-profile.component';
import { Location } from '@angular/common';
import { NotificationsService } from '../../services/notifications.service';
import { of, forkJoin } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorHandlerService } from '../../services/http-error-handler.service';
import { SalesCompanyProfileComponent } from '../sales-company-profile/sales-company-profile.component';
import { SaleAdminNotificationSettingPopupComponent } from '../../settings/sale-admin-notification-setting-popup/sale-admin-notification-setting-popup.component';

@Component({
  selector: 'app-vet-user-profile',
  templateUrl: './vet-user-profile.component.html',
  styleUrls: ['./vet-user-profile.component.scss']
})
export class VetUserProfileComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild(UserProfileComponent) userProfileComponent!: UserProfileComponent;
  @ViewChild(VetUserNotificationSettingComponent) notificationComponent!: VetUserNotificationSettingComponent;
  @ViewChild(VetProfileComponent) vetProfileComponent!: VetProfileComponent;
  @ViewChild(SalesCompanyProfileComponent) saleCompanyProfileComponent!: SalesCompanyProfileComponent;
  @ViewChild(SaleAdminNotificationSettingPopupComponent) saleAdminNotificationSettingPopupComponent!: SaleAdminNotificationSettingPopupComponent;
  readonly unsubscribe$ = new Subject<void>();
  public IsSalesCompany: boolean = false;
  public IsVet: boolean = false;
  constructor(private readonly authService: AuthService,
    private readonly userService: UserService,
    private readonly eventEmitter: EventsEmitter,
    private readonly location: Location,
    private readonly notificationsService: NotificationsService,
    private readonly httpErrorHandleService: HttpErrorHandlerService,
    private toastService: ToastService) {
  }

  initialTop = 57;
  currentTop = 57;
  scrollSub!: () => void;

  ngOnInit() {
    this.IsSalesCompany = this.authService.IsSalesCompany();
    this.IsVet = this.authService.IsVet();
    this.scrollSub = this.onWindowScroll.bind(this);
    window.addEventListener('scroll', this.scrollSub);
  }

  ngOnDestroy(): void {
    window.removeEventListener('scroll', this.scrollSub);
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngAfterViewInit() {

  }


  onWindowScroll() {
    const scrollY = window.scrollY || document.documentElement.scrollTop;

    const header = document.querySelector('.fixed-header') as HTMLElement;
    if (header) {
      if (scrollY >= this.initialTop) {
        header.style.top = '0px';
      } else {
        header.style.top = `${this.initialTop - scrollY}px`;
      }
    }
  }




  async SaveVetUserProfile() {

    const isUserDataValid = this.userProfileComponent.isFormValid();
    const isNotificationDataValid = this.IsVet ? this.notificationComponent.isFormValid() : true;
    const isCompanyDataValid = this.IsVet ? this.vetProfileComponent.isFormValid() : this.saleCompanyProfileComponent.isFormValid();
    if (!isUserDataValid) {
      this.toastService.warning("User Profile section has validation errors", "User Profile");
    }
    if (!isNotificationDataValid) {
      this.toastService.warning("Notification Setting section has validation errors", "Notification Setting ");
    }
    if (!isCompanyDataValid) {
      this.toastService.warning("Company Profile section has validation errors", "Company Profile");
    }
    if (!isUserDataValid || !isNotificationDataValid || !isCompanyDataValid) {
      return;
    }

    const userData = this.userProfileComponent.getFormData();
    const notificationData = this.IsVet ? this.notificationComponent.getFormData() : null;
    const companyData = this.IsVet ? this.vetProfileComponent.getFormData() : this.saleCompanyProfileComponent.getFormData();
    
    try {
      let userSaveSuccess = false;
      let notificationSaveSuccess = !this.IsVet; // If not vet, consider this "success"
      let companySaveSuccess = false;

      

      try {
        const response = await lastValueFrom(this.userService.postVetProfile(userData));
        //var img = userData.get("imageFile") as string;
        if (response.image) {
          this.authService.setUserImage((response.image as string));
        }else {
          this.authService.setUserImage(("assets/images/user.png" as string));
        }

        // Update user display info in top banner with the new profile information
        this.authService.updateUserDisplayInfo(response.firstName, response.lastName, response.email);

        userSaveSuccess = true;
      } catch (error) {
        if (error) {
          this.httpErrorHandleService.ShowCustomErrorMessage(error, "User Profile");
        }
      }


      try {
        if (this.IsVet && notificationData) {
          await lastValueFrom(this.notificationsService.updateVetNotifications(notificationData));
        }        
        notificationSaveSuccess = true;
      } catch (error) {
        if (error) {
          this.httpErrorHandleService.ShowCustomErrorMessage(error, "User Notification Settings");
        }
      }
      try {
        await lastValueFrom(this.userService.postMemberProfile(companyData));

        companySaveSuccess = true;
      } catch (error) {
        if (error) {
          this.httpErrorHandleService.ShowCustomErrorMessage(error, "Company Profile");
        }
      }

  
  //    // Only navigate if all saves succeeded
      if (userSaveSuccess && notificationSaveSuccess && companySaveSuccess) {
        this.location.back(); 
      }

    } catch (error) {
      //console.error('Unexpected error during save', error);
      this.toastService.error('Profile update failed'); 
    }
  }
  
}

